import { createReducer, on } from '@ngrx/store';
import {
  loadUser,
  requestError,
  requestSuccess,
  clearUser,
  changeStatusUser,
} from './client-user.action';
import { initialClientUserState, ClientUserState } from './client-user.state';

export const ClientUserReducer = createReducer(
  initialClientUserState,
  on(loadUser, (state): ClientUserState => {
    return { ...state, loading: true };
  }),

  on(changeStatusUser, (state): ClientUserState => {
    return { ...state, loading: true };
  }),

  on(requestSuccess, (state, { response }): ClientUserState => {
    return {
      error: false,
      loading: false,
      update: false,
      entity: response.response ?? null,
    };
  }),
  on(requestError, (state, { error }): ClientUserState => {
    return {
      error: error,
      loading: false,
      update: false,
      entity: null,
    };
  }),
  on(clearUser, (state): ClientUserState => {
    return {
      error: false,
      loading: false,
      update: false,
      entity: null,
    };
  })
);
